var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pcc-shell", class: { "pcc-shell-embedded": _vm.embedded } },
    [
      _c(
        "aside",
        { staticClass: "pcc-side", class: { "pcc-side-open": _vm.sideOpen } },
        [
          _c("div", { staticClass: "pcc-side-head" }, [
            _c("span", { staticClass: "pcc-side-label" }, [
              _vm._v(_vm._s(_vm.$t("message.projects.chatConversations"))),
            ]),
            _c(
              "button",
              {
                staticClass: "pcc-new",
                attrs: { type: "button" },
                on: { click: _vm.openNewThread },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("message.projects.chatNewPrivate")) + " "
                ),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "pcc-threadlist" },
            _vm._l(_vm.threads, function (th) {
              return _c(
                "div",
                {
                  key: th.id,
                  staticClass: "pcc-thread",
                  class: { "pcc-thread-active": th.id === _vm.activeThread },
                  attrs: { title: th.name },
                  on: {
                    click: function ($event) {
                      return _vm.openThread(th.id)
                    },
                  },
                },
                [
                  !th.is_private
                    ? _c("span", { staticClass: "pcc-thread-ic" }, [
                        _vm._v("#"),
                      ])
                    : _c(
                        "span",
                        { staticClass: "pcc-facepile" },
                        _vm._l(_vm.otherMembers(th).slice(0, 3), function (p) {
                          return _c(
                            "v-avatar",
                            {
                              key: p.id,
                              staticClass: "pcc-face",
                              attrs: { size: "18", color: p.color || "grey" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "white--text pcc-initials-xs" },
                                [_vm._v(_vm._s(p.initials))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                  _c("span", { staticClass: "pcc-thread-txt" }, [
                    _c("span", { staticClass: "pcc-thread-name" }, [
                      _vm._v(_vm._s(_vm.threadLabel(th))),
                    ]),
                    _c(
                      "span",
                      { staticClass: "pcc-thread-last" },
                      [
                        th.last
                          ? [
                              _vm._v(
                                _vm._s(_vm.firstName(th.last.user)) +
                                  ": " +
                                  _vm._s(th.last.body)
                              ),
                            ]
                          : _c("em", { staticClass: "pcc-thread-none" }, [
                              _vm._v("—"),
                            ]),
                      ],
                      2
                    ),
                  ]),
                  th.unread
                    ? _c("span", { staticClass: "pcc-badge" }, [
                        _vm._v(_vm._s(th.unread)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "pcc-side-section" }, [
            _c("div", { staticClass: "pcc-side-head" }, [
              _c("span", { staticClass: "pcc-side-label" }, [
                _vm._v(_vm._s(_vm.$t("message.projects.chatParticipants"))),
              ]),
              _c("span", { staticClass: "pcc-count" }, [
                _vm._v(_vm._s(_vm.participants.length)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "pcc-members" },
              _vm._l(_vm.participants, function (p) {
                return _c(
                  "div",
                  {
                    key: p.id,
                    staticClass: "pcc-member",
                    class: { "pcc-member-me": _vm.isMe(p) },
                    attrs: { title: p.name },
                  },
                  [
                    _c(
                      "v-avatar",
                      { attrs: { size: "22", color: p.color || "grey" } },
                      [
                        _c(
                          "span",
                          { staticClass: "white--text pcc-initials-sm" },
                          [_vm._v(_vm._s(p.initials))]
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "pcc-member-name" }, [
                      _vm._v(_vm._s(p.name)),
                    ]),
                    _vm.isMe(p)
                      ? _c("span", { staticClass: "pcc-you" }, [
                          _vm._v(_vm._s(_vm.$t("message.projects.chatYou"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm.sideOpen
        ? _c("div", {
            staticClass: "pcc-scrim",
            on: {
              click: function ($event) {
                _vm.sideOpen = false
              },
            },
          })
        : _vm._e(),
      _c("section", { staticClass: "pcc-main" }, [
        _c("div", { staticClass: "pcc-thread-head" }, [
          _c(
            "button",
            {
              staticClass: "pcc-hamb",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.sideOpen = !_vm.sideOpen
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-menu")])],
            1
          ),
          _c("div", { staticClass: "pcc-thread-head-txt" }, [
            _c(
              "div",
              { staticClass: "pcc-headtitle" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.activeThreadObj
                        ? _vm.threadLabel(_vm.activeThreadObj)
                        : ""
                    ) +
                    " "
                ),
                _vm.activeThreadObj && _vm.activeThreadObj.is_private
                  ? _c("span", { staticClass: "pcc-lockpill" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("message.projects.chatPrivate")) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.canManageActive
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "",
                          "x-small": "",
                          title: _vm.$t("message.projects.chatEditMembers"),
                        },
                        on: { click: _vm.openEditMembers },
                      },
                      [
                        _c("v-icon", { attrs: { "x-small": "" } }, [
                          _vm._v("mdi-account-plus"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "pcc-headmeta" }, [
              _vm._v(_vm._s(_vm.headMeta)),
            ]),
          ]),
        ]),
        _c(
          "div",
          { ref: "stream", staticClass: "pcc-stream" },
          [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "pcc-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        indeterminate: "",
                        color: "primary",
                        size: "28",
                      },
                    }),
                  ],
                  1
                )
              : !_vm.messages.length
              ? _c("div", { staticClass: "pcc-center pcc-empty" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.projects.chatEmpty")) + " "
                  ),
                ])
              : [
                  _vm._l(_vm.messages, function (msg, index) {
                    return [
                      _vm.showDay(index)
                        ? _c(
                            "div",
                            { key: "d-" + msg.id, staticClass: "pcc-day" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.dayLabel(msg.day))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      msg.id === _vm.firstUnreadId
                        ? _c(
                            "div",
                            { key: "u-" + msg.id, staticClass: "pcc-unread" },
                            [_c("span", [_vm._v(_vm._s(_vm.unreadCount))])]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          key: msg.id,
                          staticClass: "pcc-row",
                          class: [
                            {
                              "pcc-me": msg.mine,
                              "pcc-grouped": _vm.isGrouped(index),
                            },
                            msg.kind ? "pcc-sys pcc-sys-" + msg.kind : "",
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "pcc-av-slot" },
                            [
                              !_vm.isGrouped(index)
                                ? _c(
                                    "v-avatar",
                                    {
                                      attrs: {
                                        color: (msg.user || {}).color || "grey",
                                        size: "26",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "white--text pcc-initials",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s((msg.user || {}).initials)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "pcc-body" },
                            [
                              !_vm.isGrouped(index)
                                ? _c("div", { staticClass: "pcc-head" }, [
                                    _c("span", { staticClass: "pcc-name" }, [
                                      _vm._v(_vm._s((msg.user || {}).name)),
                                    ]),
                                    msg.mine
                                      ? _c(
                                          "span",
                                          { staticClass: "pcc-you-tag" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.projects.chatYou"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("span", { staticClass: "pcc-time" }, [
                                      _vm._v(_vm._s(msg.time)),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.editingId === msg.id
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "pcc-edit-box" },
                                      [
                                        _c("v-textarea", {
                                          staticClass: "pcc-edit",
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            rows: "2",
                                            "auto-grow": "",
                                          },
                                          model: {
                                            value: _vm.editBody,
                                            callback: function ($$v) {
                                              _vm.editBody = $$v
                                            },
                                            expression: "editBody",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "pcc-edit-actions" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  text: "",
                                                },
                                                on: { click: _vm.cancelEdit },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.common.cancel"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "primary",
                                                  loading: _vm.saving,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.saveEdit(msg)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.common.save"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "pcc-bubble-wrap" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pcc-text" },
                                          [
                                            msg.kind
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "pcc-sys-ic",
                                                    attrs: { size: "15" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        msg.kind ===
                                                          "field_approved"
                                                          ? "mdi-check-circle"
                                                          : msg.kind ===
                                                            "field_rejected"
                                                          ? "mdi-close-circle"
                                                          : "mdi-hammer-wrench"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(_vm._s(msg.body) + " "),
                                            msg.kind && msg.drawing_id
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "pcc-sys-link",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.openWeldMapping(
                                                          msg
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.projects.chatOpenWeldMapping"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "ic-inherit",
                                                        attrs: { size: "14" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-arrow-right"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.isGrouped(index)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pcc-time pcc-time-inline",
                                              },
                                              [_vm._v(_vm._s(msg.time))]
                                            )
                                          : _vm._e(),
                                        msg.can_edit || msg.can_delete
                                          ? _c(
                                              "span",
                                              { staticClass: "pcc-acts" },
                                              [
                                                msg.can_edit
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass: "pcc-act",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.startEdit(
                                                              msg
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                            },
                                                          },
                                                          [_vm._v("mdi-pencil")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                msg.can_delete
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "pcc-act pcc-act-danger",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmDelete(
                                                              msg
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                            },
                                                          },
                                                          [_vm._v("mdi-delete")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    msg.edited || msg.mine
                                      ? _c("div", { staticClass: "pcc-foot" }, [
                                          msg.edited
                                            ? _c(
                                                "span",
                                                { staticClass: "pcc-edited" },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.projects.chatEdited"
                                                        )
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          msg.mine
                                            ? _c(
                                                "span",
                                                { staticClass: "pcc-sent" },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        "x-small": "",
                                                        color: msg.seen_count
                                                          ? "primary"
                                                          : "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            msg.seen_count
                                                              ? "mdi-check-all"
                                                              : "mdi-check"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        msg.seen_count
                                                          ? _vm.$t(
                                                              "message.projects.chatSeenBy",
                                                              {
                                                                count:
                                                                  msg.seen_count,
                                                              }
                                                            )
                                                          : _vm.$t(
                                                              "message.projects.chatSent"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ],
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "pcc-compose" },
          [
            _c("v-textarea", {
              staticClass: "pcc-input",
              attrs: {
                outlined: "",
                dense: "",
                "hide-details": "",
                rows: "1",
                "auto-grow": "",
                placeholder: _vm.$t("message.projects.chatPlaceholder"),
              },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.send($event)
                },
              },
              model: {
                value: _vm.draft,
                callback: function ($$v) {
                  _vm.draft = $$v
                },
                expression: "draft",
              },
            }),
            _c(
              "v-btn",
              {
                staticClass: "pcc-send",
                attrs: {
                  color: "primary",
                  depressed: "",
                  loading: _vm.sending,
                  disabled: !_vm.draft.trim(),
                },
                on: { click: _vm.send },
              },
              [_vm._v(" " + _vm._s(_vm.$t("message.projects.chatSend")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.newThreadDialog,
            callback: function ($$v) {
              _vm.newThreadDialog = $$v
            },
            expression: "newThreadDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.memberPickerMode === "edit"
                        ? _vm.$t("message.projects.chatEditMembers")
                        : _vm.$t("message.projects.chatNewPrivateTitle")
                    ) +
                    " "
                ),
              ]),
              _c(
                "v-card-text",
                { staticClass: "pb-0" },
                [
                  _c("div", { staticClass: "pcc-hint mb-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.memberPickerMode === "edit"
                            ? _vm.$t("message.projects.chatEditMembersHint")
                            : _vm.$t("message.projects.chatNewPrivateHint")
                        ) +
                        " "
                    ),
                  ]),
                  _vm._l(_vm.selectableMembers, function (p) {
                    return _c(
                      "div",
                      { key: p.id, staticClass: "pcc-pick" },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0 pt-0",
                          attrs: {
                            dense: "",
                            "hide-details": "",
                            value: p.id,
                            label: p.name,
                          },
                          model: {
                            value: _vm.newThreadMembers,
                            callback: function ($$v) {
                              _vm.newThreadMembers = $$v
                            },
                            expression: "newThreadMembers",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.newThreadDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        small: "",
                        loading: _vm.creating,
                        disabled:
                          _vm.memberPickerMode === "create" &&
                          !_vm.newThreadMembers.length,
                      },
                      on: { click: _vm.submitMemberPicker },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.memberPickerMode === "edit"
                              ? _vm.$t("message.common.save")
                              : _vm.$t("message.projects.chatCreate")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "320" },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v(_vm._s(_vm.$t("message.projects.chatConfirmDelete"))),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        small: "",
                        loading: _vm.deleting,
                      },
                      on: { click: _vm.doDelete },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("message.common.delete")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }